import { chatLogin } from "../../../helpers/apis";
import { loginSuccess, logoutUserSuccess, apiError } from "./reducer";
import { setAuthorization } from "../../../helpers/api_helper";
import { jwtDecode } from "jwt-decode";

export const loginUser = (user, history) => async (dispatch) => {
  try {
    // Call login API
    // New backend response structure: { error: false, msg: "Success", data: {...}, token: "..." }
    const response = await chatLogin({
      email: user.email,
      password: user.password,
    });

    // Handle new response structure: { error: false, msg: "Success", data: {...}, token: "..." }
    if (response && !response.error) {
      const token = response.token;
      const userData = response.data;

      if (token && userData) {
        // Decode JWT to get expiry time
        let decodedToken;
        try {
          decodedToken = jwtDecode(token);
        } catch (decodeError) {
          console.error("Token decode error:", decodeError);
          decodedToken = { exp: Date.now() / 1000 + 86400 }; // Default 24 hours
        }

        // Store token and user data in localStorage
        const authData = {
          token: token,
          user: userData
        };

        localStorage.setItem("authUser", JSON.stringify(authData));
        localStorage.setItem("expiryAt", decodedToken.exp * 1000);
        localStorage.setItem("expiryIn", decodedToken.exp * 1000 - Date.now());

        // Set Axios Authorization header
        setAuthorization();

        // Dispatch success - clear any previous errors
        dispatch(loginSuccess({ token, user: userData }));

        // Redirect to dashboard immediately
        history.navigate("/dashboard");
      } else {
        dispatch(apiError("Login response format is incorrect. Token or user data is missing."));
      }
    } else {
      // Handle error response
      const errorMessage = response?.msg || response?.message || "Invalid login credentials";
      dispatch(apiError(errorMessage));
    }
  } catch (error) {
    console.error("Login Error:", error);
    dispatch(apiError(error.message || "Login failed. Please try again."));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("expiryAt");
    localStorage.removeItem("expiryIn");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    console.error("Logout Error:", error);
    dispatch(apiError(error.message || "An error occurred during logout."));
  }
};
